import BackedEnum from '@/enums/BackedEnum';
import PetSpecies from '@/enums/PetSpecies';

export default class SpeciesTreatedType extends BackedEnum {}

SpeciesTreatedType.Dog = 'DOG';
SpeciesTreatedType.Cat = 'CAT';
SpeciesTreatedType.Horse = 'HORSE';
SpeciesTreatedType.Bird = 'BIRD';
SpeciesTreatedType.ReptileAmphibian = 'REPTILE_AMPHIBIAN';
SpeciesTreatedType.Fish = 'FISH';
SpeciesTreatedType.FarmAnimal = 'FARM_ANIMAL';
SpeciesTreatedType.OtherExotic = 'OTHER_EXOTIC';
SpeciesTreatedType.SmallMammal = 'SMALL_MAMMAL';

SpeciesTreatedType.fromPetSpecies = (species) => {
  switch (species) {
    case PetSpecies.Rabbit:
      return SpeciesTreatedType.SmallMammal;
    case PetSpecies.Reptile:
    case PetSpecies.Amphibian:
      return SpeciesTreatedType.ReptileAmphibian;
    case PetSpecies.Spider:
    case PetSpecies.Other:
      return SpeciesTreatedType.OtherExotic;
    default:
      return null;
  }
};

SpeciesTreatedType.getIcon = (species) => {
  switch (species) {
    case SpeciesTreatedType.Dog:
    case SpeciesTreatedType.Cat:
    case SpeciesTreatedType.Fish:
    case SpeciesTreatedType.Horse:
      return ['fal', species.toLowerCase()];
    case SpeciesTreatedType.Bird:
      return ['fal', 'crow'];
    case SpeciesTreatedType.ReptileAmphibian:
      return ['fal', 'snake'];
    case SpeciesTreatedType.FarmAnimal:
      return ['fal', 'sheep'];
    case SpeciesTreatedType.SmallMammal:
      return ['fal', 'rabbit'];
    case SpeciesTreatedType.OtherExotic:
      return ['fal', 'monkey'];
    default:
      return ['fal', 'paw'];
  }
};
